import React, { useRef } from "react";
import { graphql } from "gatsby";
import loadable from '@loadable/component';
import Header from '../components/Header';
import { useHasBeenVisible } from '../hooks/useVisibility';
import PageLayout from "../layouts/PageLayout";
import SEO from "../components/seo";
import '../scss/pages/contact.scss';

const BelowTheFold = loadable(()=> import('../components/BelowTheFold/Contact'));

const ContactPage = ({ data, location: { pathname } }) => {
  const { seo, content } = data.page.childMarkdownRemark.frontmatter;
  const { businessInfo, services, blockImage } = data;
  const { html } = data.page.childMarkdownRemark;
  const mainVisible = useRef();
  const hasScrolled = useHasBeenVisible(mainVisible);
  return (
    <PageLayout>
      <SEO title={seo.title} description={seo.metaDescription} ogImage={seo.ogImage.childImageSharp.fixed}  />
      <Header
        subheading={content.headerSection.subheading}
        heading={content.headerSection.heading}
        background={content.headerSection.background}
        color={content.headerSection.color}
      />
      <main ref={mainVisible}>
        {hasScrolled && (
          <BelowTheFold
            blockImage={blockImage}
            body={html}
            businessInfo={businessInfo}
            services={services}
          />
        )}
      </main>
    </PageLayout>
  );
};

export const ContactPageQuery = graphql`
  query ContactPageQuery {
    page: file(sourceInstanceName: {eq: "pages"}, name: {eq: "contact"}) {
      id
      childMarkdownRemark {
        fields {
          slug
        }
        html
        frontmatter {
          seo {
            title
            metaDescription
            ogImage {
              childImageSharp {
                fixed(width: 1200, height: 630, quality: 70) {
                  src
                }
              }
            }
          }
          content {
            headerSection {
              background {
                childImageSharp {
                  fluid(maxWidth: 1440, quality: 50) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
              color
              subheading
              heading
            }
          }
        }
      }
    }
    businessInfo: file(relativePath: { eq: "business-info.md"}) {
      childMarkdownRemark {
        frontmatter {
          name
          address
          city
          state
          zip
          email
          phoneNumber
          displayNumber
        }
      }
    }
    blockImage: file(relativePath: {eq: "cnc-mill.jpg"}) {
      childImageSharp {
        fluid (maxWidth: 1440, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    services: allFile(filter: {sourceInstanceName: {eq: "services"}}) {
      nodes {
        childMarkdownRemark {
          fields {
            slug
          }
          frontmatter {
            title
            photo {
              childImageSharp {
                fluid(maxWidth: 300, maxHeight: 188, quality: 50) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default ContactPage;
